import { ProductionOrder } from '@app:types';
import { SortingKeys } from '@ellure/api-client-admin/build/@api/order-register-endpoints';
import { BaseApiClass } from '../base-api-class';
import { PaginationResponse } from '../endpoint';

type CreateProductDto = {
  type: 'nailgel' | 'nailgel-sample' | 'lipstick';
  derivedFrom: {
    expectedShade: string;
    isSample?: string;
  };
};

type CreateOrderDto = {
  name: string;
  email: string;
  content: CreateProductDto[];
};

export type FetchProductionOrdersDto = {
  page?: number;
  limit?: number;
  showAll?: boolean;
  sort?: SortingKeys[];
};

export class ProductionOrderApi extends BaseApiClass {
  public readonly fetchList = this.createEndpoint<FetchProductionOrdersDto, PaginationResponse<ProductionOrder>>({
    method: 'get',
    endpoint: ['ellure', 'orders'],
    requestConfig: (dto) => ({
      query: {
        page: dto.page?.toString(),
        limit: dto.limit?.toString(),
      },
    }),
  });

  /** Commits a new order to the register. */
  public readonly createProduct = this.createEndpoint<CreateOrderDto, never>({
    method: 'post',
    endpoint: ['orders'],
    requestConfig: (dto) => ({
      data: {
        metadata: {
          name: dto.name,
          email: dto.email,
          orderDate: new Date().toJSON(),
        },
        content: dto.content,
      },
    }),
  });
}
